module.exports = __webpack_public_path__ + "img/system_3.83e87278.png";